<mat-toolbar>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

            <span class="small"><small>&copy;&nbsp;Copyright {{year}}</small></span>

        <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <a mat-button target="_blank" class="text-success"
            href="https://sevenskies.co.ke/"><small><b>THE SEVENSKIES</b></small></a>
        </div>

    </div>

</mat-toolbar>
